import { Injectable } from '@angular/core';
import { EventObject } from '../models/event.model';
import { ArrayHelper } from 'src/app/shared/helpers/array.helper';

@Injectable({
  providedIn: 'root'
})
export class EventGeneratorService {
  constructor() { }

  mapDataToEvent({ id, commandName, oldValues, newValues, isListDiff }: EventObject) {
    const diffValues = this.compareObjects(oldValues, newValues, isListDiff || false);
    return {
      id,
      commandName,
      oldValues: diffValues.resultOld,
      newValues: diffValues.resultNew
    };
  }

  private compareObjects(oldObj: any, newObj: any, isListDiff: boolean) {
    let resultOld: any = {};
    let resultNew: any = {};
    // Keep track of the keys we've seen
    let keys = new Set();

    for (const key in oldObj) {
      keys.add(key);

      if (!(key in newObj)) {
        resultOld[key] = oldObj[key];
      } else {
        const oldValue = oldObj[key];
        const newValue = newObj[key];
        if (oldValue !== newValue) {
          const aIsObject = typeof oldValue === 'object';
          const bIsObject = typeof newValue === 'object';
          const aIsArray = Array.isArray(oldValue);
          const bIsArray = Array.isArray(newValue);
          if (aIsObject && bIsObject && !aIsArray && !bIsArray) {
            // Both are objects, recurse
            const update = this.compareObjects(oldValue, newValue, isListDiff);
            if (update) {
              resultOld[key] = update.resultOld;
              resultNew[key] = update.resultNew;
            }
          } else if (aIsArray && bIsArray) {
            // Check if contains objects or plain values
            const objectItems = typeof oldValue[0] === 'object' && typeof newValue[0] === 'object';
            let oldArray = (oldValue as Array<any>);
            let newArray = (newValue as Array<any>);
            if (objectItems) {
              oldArray = ArrayHelper.sortArray([...oldArray], 'id');
              newArray = ArrayHelper.sortArray([...newArray], 'id');
              // Contains the elements that have been removed from New array
              const removedElements = ArrayHelper.getObjectDifference(oldArray, newArray);

              // Contains the elements that have been added into the New array
              const addedElements = ArrayHelper.getObjectDifference(newArray, oldArray);

              // exclude new items
              const newArrayValues = newValue.filter((val: any) => !addedElements.includes(val));
              // exclude removed items
              const oldArrayValues = oldValue.filter((val: any) => !removedElements.includes(val));

              // checking if there is changes in the elements insice of the arrays
              let newValuesWithChanges = false;
              if (newArrayValues.length === oldArrayValues.length) {
                newArrayValues.map((newArrayData, index) => {
                  const newArrayObj = newArrayData;
                  const oldArrayObj = oldArrayValues[index];

                  // getting objec keys from the new array
                  const keys1 = Object.keys(newArrayObj);

                  // Check if property values are different
                  for (let key of keys1) {
                    if (oldArrayObj[key] !== undefined && newArrayObj[key] !== undefined && Array.isArray(oldArrayObj[key]) && Array.isArray(newArrayObj[key])) {
                      // array with objects are not considered here
                      // maybe do this with recursion in the future
                      const oldArr = oldArrayObj[key].sort();
                      const newArr = newArrayObj[key].sort();
                      if (oldArr.length !== newArr.length) {
                        newValuesWithChanges = true;
                      } else if (!oldArr.every((e: any) => newArr.includes(e))) {
                        newValuesWithChanges = true;
                      }
                    } else if (oldArrayObj[key] !== undefined && newArrayObj[key] !== oldArrayObj[key]) {
                      newValuesWithChanges = true;
                    }
                  }
                  if (newValuesWithChanges && isListDiff) {
                    ArrayHelper.pushToArray(resultOld, key, [oldArrayObj]);
                    ArrayHelper.pushToArray(resultNew, key, [newArrayObj]);
                    newValuesWithChanges = false;
                  }
                })
              }

              if ((removedElements.length > 0 || addedElements.length > 0 || newValuesWithChanges) && !isListDiff) {
                resultOld[key] = oldValue;
                resultNew[key] = newValue;
              }
              if (removedElements.length > 0 && isListDiff) {
                ArrayHelper.pushToArray(resultOld, key, removedElements);
              }
              if (addedElements.length > 0 && isListDiff) {
                ArrayHelper.pushToArray(resultNew, key, addedElements);
              }

            } else {
              // Plain values
              const commonOldItems = oldArray.every(oldVal => newArray.includes(oldVal))
              const commonNewItems = newArray.every(newVal => oldArray.includes(newVal))
              if (!commonNewItems || !commonOldItems) {
                // Some values are different between the two collections
                resultOld[key] = oldValue;
                resultNew[key] = newValue;
              }
            }
          } else {
            // Different values
            resultOld[key] = oldValue;
            resultNew[key] = newValue;
          }
        }
      }
    }
    // Add in any that are in `newObj` but weren't in `oldObj`
    for (const key in newObj) {
      if (!keys.has(key)) {
        resultNew[key] = newObj[key];
      }
    }
    return { resultOld, resultNew };
  }
}
